export default "__VITE_ASSET__fe93ecc0__"